/* Setting Current Product Media to localstorage */
localStorage.setItem("current_product_media", JSON.stringify(currentProductJson.media));
  
var variantId = currentVariantJson.id.toString()
function associatedVariantIdUpdate(Id){
  variantId = Id
  associateVariantImageToSlider()
}
/* =========== Associate Variant Image functionality ============== */
function associateVariantImageToSlider(){
  $(".customImageLoader").show();
  /* Grabbing the current product media items from localstorage */
  var grabCurrentProductMedia = currentProductJson.media;
  /* Matching Current/Selected Variant Id with All Product Images Alt text */
  var variantIdMatchedImages = grabCurrentProductMedia.filter(image =>
    "alt" in image && image.alt !== '' && image.alt !== null &&
    image.alt.includes(variantId)
  );
  
  // Only create result if we have matched images. If none matched, keep result empty (so fallback runs).
  var result = [];
  if (variantIdMatchedImages && variantIdMatchedImages.length > 0) {
    result = [
      variantIdMatchedImages[0], // Grab the first index of variantIdMatchedImages array
      ...variantIdMatchedImages.slice(1) // Grab the remaining values from variantIdMatchedImages array (excluding the first index)
    ];
  }

  /* Destroying Flickity Slider: Main */
  var mainSlider = $('.pdp-product-slideshow').flickity();
  mainSlider.flickity('destroy');
  
  /* Removing complete Div Data: Main Slider Div */
  var productWrapperMainSlider = document.querySelector('.Product__Wrapper');
  var carouselCellsMain = productWrapperMainSlider.querySelectorAll('.Product__SlideItem');
  carouselCellsMain.forEach(function(carouselCellMain) {
    carouselCellMain.parentNode.removeChild(carouselCellMain);
  });
  
  /* Removing Carousel Cells: NavBar Slides */
  var productWrapperNav = document.querySelector('.Product__SlideshowNav');
  var carouselCellsNav = productWrapperNav?.querySelectorAll('.carousel-cell');
  carouselCellsNav?.forEach(function(carouselCellNav) {
    carouselCellNav?.parentNode.removeChild(carouselCellNav);
  });
  
  /* Removing data-flickity-config attribute */
  var productSlideshowImage = document.querySelector('.product_slideshow_image');
  if (productSlideshowImage) productSlideshowImage.removeAttribute('data-flickity-config');
  
  if (result.length){
    var positionCounter = 0;
    $.each(result, function (index, image) {
      var isVideo = (image?.media_type === 'video') || (image?.media_type === 'external_video');
      var buttonColor = '';

      /* Ignoring Video for indexing */
      if (!isVideo) positionCounter++;

      /* Updating Icon color using Alt text */
      if ("alt" in image && image.alt !== '' && image.alt !== null && image.alt.indexOf('show-white-buttons') !== -1) 
        buttonColor = 'black'
      
      /* ========= Append HTML based on the result: Main Slider ========= */
      var htmlMain = '<div id="Image' + image.id + '" class="Product__SlideItem Product__SlideItem--';
      htmlMain += (image.media_type === 'video') ? 'video' : 'image';
      htmlMain += ' Carousel__Cell ' + (index === 0 ? 'is-selected' : '');
      htmlMain += '" data-image-position-ignoring-video="' + (positionCounter - 1) + '" data-image-position="' + (index + 1) + '" data-image-id="' + image.id + '" data-image-bg="'+ buttonColor +'">';
      htmlMain += '<div class="AspectRatio AspectRatio--withFallback" style="padding-bottom: ' + (100.0 / image.aspect_ratio) + '%; --aspect-ratio: ' + image.aspect_ratio + ';">';
      if (image.media_type === 'video') {
        htmlMain += '<video class="js-slideItemVideo slideItemVideo" poster="' + image.preview_image.src + '" width="480" height="320" muted loop playsinline>';
        $.each(image.sources, function (i, source) {
          if (source.format === 'mp4') {
            htmlMain += '<source src="' + source.url + '" type="' + source.mime_type + '">';
            htmlMain += '<track kind="captions">';
          }
        });
        htmlMain += '</video>';
        htmlMain += '<button class="video__play-button">';
        htmlMain += '<div class="video__play-button videoPlayerButton iconPlay goal" aria-label="Play/Pause Video" tabindex="-1"></div>';
        htmlMain += '</button>';
      } else {
        htmlMain += '<img class="Image--lazyLoad Image--fadeIn" src="' + (image.src) + '"';
        htmlMain += ' width="" height="" data-src="' + image.src + '"';
        htmlMain += ' data-sizes="auto" data-expand="-100"';
        htmlMain += ' data-alt="' + image.alt + '" data-max-width="' + image.width + '" data-max-height="' + image.height + '"';
        htmlMain += ' data-original-src="' + image.src + '">';
      }
      htmlMain += '</div></div>';
      $('.pdp-product-slideshow').append(htmlMain);
      
      /* ======== Append HTML based on the result: Navbar Slider ========= */
      var is_video = false;
      var navBarSlides = $('.Product__SlideshowNavScroller .flickity-slider');
      var playVideoLabel = "Play video";
      
      is_video = image.media_type == "video" || image.media_type == "external_video";
      var html = '<div class="carousel-cell" role="group" aria-roledescription="image">';
      html += '<button role="button" aria-label="Thumbnail image ' + (index + 1) + '. ' + image.alt + '" tabindex="0" data-image-id="' + image.id + '" class="Product__SlideshowNavImage';
      html += (is_video ? ' Product__SlideshowNavImage--video' : '') + ' AspectRatio';
      html += (index === 0 ? ' is-selected' : '') + '" style="--aspect-ratio: ' + image.aspect_ratio + '">';
      html += '<img class="Image--lazyLoad Image--fadeIn" src="' + image.preview_image.src + '" data-src="' + image.preview_image.src + '" alt="' + image.alt + '">';
      if (is_video) {
        html += '<a class="Product__SlideshowNavPlay pdp-product-slideshowNavPlay" data-action="play-video" role="button" aria-label="' + playVideoLabel + '">';
        html += `<svg class="Icon Icon--play-outline" role="presentation" width="36" height="35" viewBox="0 0 36 35" fill="none">
                    <path d="M17.6997 33.6922C26.9226 33.6922 34.3993 26.3738 34.3993 17.3461C34.3993 8.31841 26.9226 1 17.6997 1C8.47669 1 1 8.31841 1 17.3461C1 26.3738 8.47669 33.6922 17.6997 33.6922Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M14.8944 12.6519L23.0821 17.279L14.8944 21.9061L14.8944 12.6519Z" stroke="white" stroke-width="1.5"></path>
                 </svg>`;
        html += '</a>';
      }
      html += '</button>';
      html += '</div>';
      
      navBarSlides.append(html);
      $(".customImageLoader").hide();
    });
  } else {
    var navBarSlides = $('.Product__SlideshowNavScroller .flickity-slider');
    var positionCounter = 0;

    /* Checking if Variant contains Feature Media */
    if (currentVariantJson.featured_media && currentVariantJson.featured_media !== ''){
      /* Separating matched and unmatched images */
      var matchedImages = grabCurrentProductMedia.filter(function (image) {
        return currentVariantJson.featured_media.id === image.id;
      });
      var unmatchedImages = grabCurrentProductMedia.filter(function (image) {
        return currentVariantJson.featured_media.id !== image.id;
      });
      
      /* Append matched images first */
      matchedImages.forEach(function (image) {
        appendImageToSlideshow(image);
      });
      /* Append unmatched images afterwards */
      unmatchedImages.forEach(function (image) {
        appendImageToSlideshow(image);
      });
    } else {
      grabCurrentProductMedia.forEach(function (image) {
        appendImageToSlideshow(image);
      });
    }
    
    /* ========= Append HTML based on the result: Main Slider ========= */
    function appendImageToSlideshow(image) {
      var isVideo = (image.media_type === 'video') || (image.media_type === 'external_video');
      var buttonColor = '';
      var is_video = false;
      /* Ignoring Video for indexing */
      if (!isVideo) positionCounter++;
      var selectedIndex = (currentVariantJson.featured_media && currentVariantJson.featured_media.id === image.id) ? 0 : positionCounter;
      var htmlMain = '<div id="Image' + image.id + '" class="Product__SlideItem Product__SlideItem--';
      htmlMain += (image.media_type === 'video') ? 'video' : 'image';
      htmlMain += ' Carousel__Cell ' + (selectedIndex === 0 ? 'is-selected' : '');
      htmlMain += '" data-image-position-ignoring-video="' + (positionCounter - 1) + '" data-image-position="' + selectedIndex + '" data-image-id="' + image.id + '" data-image-bg="' + buttonColor + '">';
      htmlMain += '<div class="AspectRatio AspectRatio--withFallback" style="padding-bottom: ' + (100.0 / image.aspect_ratio) + '%; --aspect-ratio: ' + image.aspect_ratio + ';">';
    
      if (image.media_type === 'video') {
        htmlMain += '<video class="js-slideItemVideo slideItemVideo" poster="' + image.preview_image.src + '" width="480" height="320" muted loop playsinline>';
        image.sources.forEach(function (source) {
          if (source.format === 'mp4') {
            htmlMain += '<source src="' + source.url + '" type="' + source.mime_type + '">';
            htmlMain += '<track kind="captions">';
          }
        });
        htmlMain += '</video>';
        htmlMain += '<button class="video__play-button">';
        htmlMain += '<div class="video__play-button videoPlayerButton iconPlay goal" aria-label="Play/Pause Video" tabindex="-1"></div>';
        htmlMain += '</button>';
      } else {
        htmlMain += '<img class="Image--lazyLoad Image--fadeIn" src="' + image.src + '"';
        htmlMain += ' width="" height="" data-src="' + image.src + '"';
        htmlMain += ' data-sizes="auto" data-expand="-100"';
        htmlMain += ' data-alt="' + image.alt + '" data-max-width="' + image.width + '" data-max-height="' + image.height + '"';
        htmlMain += ' data-original-src="' + image.src + '">';
      }
      htmlMain += '</div></div>';
      $('.pdp-product-slideshow').append(htmlMain);
      
      /* ======== Append HTML based on the result: Navbar Slider ======== */
      var is_video = image.media_type == "video" || image.media_type == "external_video";
      var playVideoLabel = "Play video";
      var html = '<div class="carousel-cell" role="group" aria-roledescription="image">';
      html += '<button role="button" aria-label="Thumbnail image ' + (positionCounter) + '. ' + image.alt + '" tabindex="0" data-image-id="' + image.id + '" class="Product__SlideshowNavImage';
      html += (is_video ? ' Product__SlideshowNavImage--video' : '') + ' AspectRatio';
      html += (selectedIndex === 0 ? ' is-selected' : ''); 
      html += '" style="--aspect-ratio: ' + image.aspect_ratio + '">';
      html += '<img class="Image--lazyLoad Image--fadeIn" data-src="' + image.preview_image.src + '" alt="' + image.alt + '">';
    
      if (is_video) {
        html += '<a class="Product__SlideshowNavPlay pdp-product-slideshowNavPlay" data-action="play-video" role="button" aria-label="' + playVideoLabel + '">';
        html += `<svg class="Icon Icon--play-outline" role="presentation" width="36" height="35" viewBox="0 0 36 35" fill="none">
                    <path d="M17.6997 33.6922C26.9226 33.6922 34.3993 26.3738 34.3993 17.3461C34.3993 8.31841 26.9226 1 17.6997 1C8.47669 1 1 8.31841 1 17.3461C1 26.3738 8.47669 33.6922 17.6997 33.6922Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M14.8944 12.6519L23.0821 17.279L14.8944 21.9061L14.8944 12.6519Z" stroke="white" stroke-width="1.5"></path>
                  </svg>`;
        html += '</a>';
      }
      html += '</button>';
      html += '</div>';
      
      /* Showing Selected Slider Image on the top on the Nav Bar Slider */
      if (selectedIndex === 0) {
        navBarSlides.prepend(html);
      } else {
        navBarSlides.append(html);
      }
    }
    $(".customImageLoader").hide();
  }
  
  $('.pdp-product-slideshow').flickity();
  showClickedImageOnSlider()
  flickitySettings();
  handleFlickityButtons();
  // initializeCarousel();
  
  /* Moving Wishlist Wrapper after Product Carousel Cells */
  if ($window.width() > 980) {
    $(".wish-share-link-wrapper").appendTo(".pdp-product-slideshow");
  }
  
  $('.videoPlayerButton').click(function() {
    var video = $(this).closest(".Product__SlideItem--video").find('.js-slideItemVideo')[0];
    if (video.paused == true) {
      $(video).trigger('play');
      $(this).removeClass('iconPlay')
    } else {
      $(video).trigger('pause');
      $(this).removeClass('iconPause').addClass('iconPlay');
    }
  })
}

/* Removing Selected Class From all the cells */
function removeSelectedClass(slideItems) {
  slideItems.forEach(item => {
    item.classList.remove('is-selected');
  });
}

/* When user clicks on the Nav Slider- Showing Clicked Image on the Main Slider */
function showClickedImageOnSlider() {
  var carouselCells = document.querySelectorAll('.carousel-cell');
  var slideItems = document.querySelectorAll('.Product__SlideItem');
  carouselCells.forEach(cell => {
    cell.addEventListener('click', function() {
      /* Pausing all the videos by deafult */
      $("video").each(function () {
        this.pause();
      }); 
      var imageId = this.querySelector('button').getAttribute('data-image-id');
      var matchingSlideItem = document.querySelector(`.Product__SlideItem[data-image-id="${imageId}"]`);

      /* Remove the "is-selected" class from all slide items */
      removeSelectedClass(slideItems);
      if (matchingSlideItem) matchingSlideItem.classList.add('is-selected');
      
      /* Updating Icon Color if image contains Alt text */
      var grabIconColor = matchingSlideItem.getAttribute('data-image-bg');
      if (grabIconColor && grabIconColor === 'black') {
        $('.pdp-product-gallery').addClass('image--black');
      } else {
        $('.pdp-product-gallery').removeClass('image--black');
      }
    });
  });
}  